import { useEffect } from 'react';
import { atendimentoApi } from './atendimento-api';
import { useSessao } from './sessao';

/**
 * Sinal de vida do painel, uma vez por minuto, enquanto houver alguém logado.
 *
 * O servidor passou a tirar do plantão quem fica alguns minutos sem dar sinal (30/09): sem
 * isso, o atendente que fechava o computador continuava "disponível" no Monitor e a fila
 * caía numa tela que ninguém estava vendo. Em troca, o batimento precisa existir em
 * **qualquer** tela — senão um supervisor parado no Monitor ou nos Relatórios viraria
 * ausente no meio do expediente.
 *
 * Por isso mora nas duas molduras (a do painel e a da estação), e não na caixa de entrada.
 * Bater não deixa ninguém disponível: só mantém viva a presença que a pessoa escolheu.
 */
export function useSinalDePresenca(): void {
  const usuario = useSessao((e) => e.usuario);

  useEffect(() => {
    if (!usuario) return;
    const bater = () => void atendimentoApi.sinalDePresenca().catch(() => undefined);
    bater();
    const sinal = setInterval(bater, 60_000);
    return () => clearInterval(sinal);
  }, [usuario]);
}
